import { useQuery } from 'react-query';

import { getMilestones as queryFn } from 'api/endPoints/getMilestones';

import { IMilestones } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

interface IUseQueryGetMilestonesParams {
    contractId: number | undefined;
    filter?: string;
}

export const useQueryGetMilestones = ({ contractId, filter }: IUseQueryGetMilestonesParams) => {
    return useQuery<IMilestones[], QueryError>(
        ['phasePerformanceMilestones', contractId, filter],
        () => queryFn({ contractId: contractId!, filter }),
        { enabled: Boolean(contractId) },
    );
};
